<template>
  <v-layout row wrap>
    <v-flex>
      <v-layout row wrap>
        <v-flex xs12 md12 sm12 lg12 pl-3 pr-3 pd-3 pt-2>
          <!-- Screening selection -->
          <v-select
            v-model="screener"
            :items="screenings"
            :item-text="`title.${$i18n.locale}`"
            item-value="id"
            :label="$t('analytics.label.screeners')"
            return-object
            color="primary"
            @change="fetchEventUserCountAnalytics"
          ></v-select>

          <v-layout row wrap v-if="screener != null">
            <v-select
              :items="chartFrequency"
              item-text="name"
              item-value="value"
              v-model="frequency"
              :label="
                $t(
                  'screener.save.overview.section.screening_timelines.chart_label_frequency'
                )
              "
              dense
              @input="onChangeFrequency"
            ></v-select>
          </v-layout>
          <v-layout v-if="frequency == 'custom'" row wrap>
            <v-flex xs12>
              <DateTimePicker
                key="startTime"
                :label="
                  $t(
                    'screener.save.overview.section.screening_timelines.chart_label_start_date'
                  )
                "
                datetime="startTime"
                v-model="startTime"
              />
              <DateTimePicker
                key="sendTime"
                :label="
                  $t(
                    'screener.save.overview.section.screening_timelines.chart_label_end_date'
                  )
                "
                datetime="endTime"
                v-model="endTime"
              />
              <v-btn
                text
                color="primary"
                @click="fetchEventUserCountAnalytics"
                >{{ $t('rms.button.go') }}</v-btn
              >
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="screener != null">
            <v-flex xs12>
              <div class="text-xs-center text-md-center">
                <h3>{{ $t('analytics.graph.heading.entity_user_count') }}</h3>
              </div>
              <v-spacer></v-spacer>
              <div>
                <LineChart
                  v-if="isChartDataLoaded"
                  :chartData="chartData"
                  :options="chartOptions"
                />
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
import LineChart from './LineChart';
import i18n from '@/i18n';
import {mapGetters} from 'vuex';
import {utcToTz} from '@/helper';
import DateTimePicker from '@/components/DateTimePicker';

export default {
  name: 'EventUserCount',
  props: {
    screening: {
      type: Object,
      default: null,
    },
  },
  components: {
    LineChart,
    DateTimePicker,
  },
  data() {
    return {
      chartData: null,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          onClick: null,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                stepSize: 1,
              },
            },
          ],
        },
      },
      isChartDataLoaded: false,
      chartFrequency: [
        {
          name: i18n.t(
            'screener.save.overview.section.screening_timelines.chart_frequency_last_one_hour'
          ),
          value: 'last_one_hour',
        },
        {
          name: i18n.t(
            'screener.save.overview.section.screening_timelines.chart_frequency_last_three_hour'
          ),
          value: 'last_three_hour',
        },
        {
          name: i18n.t(
            'screener.save.overview.section.screening_timelines.chart_frequency_last_six_hour'
          ),
          value: 'last_six_hour',
        },
        {
          name: i18n.t(
            'screener.save.overview.section.screening_timelines.chart_frequency_last_twelve_hour'
          ),
          value: 'last_twelve_hour',
        },
        {
          name: i18n.t(
            'screener.save.overview.section.screening_timelines.chart_frequency_today'
          ),
          value: 'today',
        },
        {
          name: i18n.t(
            'screener.save.overview.section.screening_timelines.chart_frequency_yesterday'
          ),
          value: 'yesterday',
        },
        {
          name: i18n.t(
            'screener.save.overview.section.screening_timelines.chart_frequency_this_week'
          ),
          value: 'this_week',
        },
        {
          name: i18n.t(
            'screener.save.overview.section.screening_timelines.chart_frequency_last_week'
          ),
          value: 'last_week',
        },
        {
          name: i18n.t(
            'screener.save.overview.section.screening_timelines.chart_frequency_this_month'
          ),
          value: 'this_month',
        },
        {
          name: i18n.t(
            'screener.save.overview.section.screening_timelines.chart_frequency_last_month'
          ),
          value: 'last_month',
        },
        {
          name: i18n.t(
            'screener.save.overview.section.screening_timelines.chart_frequency_this_year'
          ),
          value: 'this_year',
        },
        {
          name: i18n.t(
            'screener.save.overview.section.screening_timelines.chart_frequency_last_year'
          ),
          value: 'last_year',
        },
        {
          name: i18n.t(
            'screener.save.overview.section.screening_timelines.chart_frequency_custom_dates'
          ),
          value: 'custom',
        },
      ],
      frequency: 'today',
      startTime: null,
      endTime: null,
      start: false,
      end: false,
      screenings: [],
      screener: this.screening,
    };
  },
  watch: {
    /** Emitting whole Objs once overrides actual obj in paraent */
    startTime() {
      this.$emit('update:startTime', this.startTime);
    },
    endTime() {
      this.$emit('update:endTime', this.endTime);
    },
  },
  computed: {
    ...mapGetters('company', {
      timezone: 'getSelectedCompanyTimezone',
    }),
  },
  currentLocale() {
    return this.$i18n.locale;
  },
  created() {
    this.getAllScreeningsFromApi();
    this.fetchEventUserCountAnalytics();
  },

  methods: {
    onChangeFrequency() {
      if (this.frequency != 'custom') {
        this.fetchEventUserCountAnalytics();
      }
    },

    async getAllScreeningsFromApi() {
      try {
        var response = await this.$store.dispatch('screener/list');
        this.screenings = response.screeners.data;
      } catch (error) {
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      }
    },

    async fetchEventUserCountAnalytics() {
      try {
        if (this.screener == null) {
          return;
        }

        if (
          this.frequency == 'custom' &&
          this.endTime == null &&
          this.startTime == null
        ) {
          throw new Error(
            i18n.t(
              'screener.save.overview.section.screening_timelines.charts_error_please_select_dates'
            )
          );
        }
        var result = await this.$store.dispatch(
          'analytics/fetchEntityUserCount',
          {
            entity_id: this.screener.id,
            entity_type: 'event',
            start_time: this.startTime,
            end_time: this.endTime,
            frequency: this.frequency,
            timezone: this.timezone,
          }
        );
        if (result.analytics.labels.length > 0 && !result.analytics.in_days) {
          let self = this;
          result.analytics.labels.forEach(function(element, index) {
            result.analytics.labels[index] = utcToTz(element, self.timezone);
          });
        }
        this.chartData = result.analytics;
        this.chartData['datasets'][0]['borderColor'] = 'rgb(91, 162, 238)';
        this.isChartDataLoaded = true;
      } catch (error) {
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      }
    },
  },
};
</script>
